import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell, { authInputClass } from "./AuthShell";
import { useAuth } from "./AuthContext";

const PERSIAN_ONLY = "[\\u0600-\\u06FF\\s]+";

const SignUpPage = () => {
  const [form, setForm] = useState({
    phone: "",
    firstName: "",
    lastName: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { requestRegisterCode } = useAuth();

  const update = (field) => (event) =>
    setForm((prev) => ({ ...prev, [field]: event.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (form.phone.length !== 11) {
      setError("لطفا شماره موبایل 11 رقمی وارد کنید");
      return;
    }

    setLoading(true);
    try {
      await requestRegisterCode(form);
      navigate("signUpVerify");
    } catch (requestError) {
      setError(
        requestError.response?.status === 409
          ? "شماره تکراری را میباشد"
          : "لطفا بعدا تلاش کنید"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="ثبت نام"
      altLabel="ورود"
      altTo="/Login"
      errors={[error]}
      loading={loading}
      submitLabel="دریافت کد تایید"
      onSubmit={handleSubmit}
    >
      <input
        name="mobile"
        type="tel"
        inputMode="numeric"
        autoComplete="tel"
        placeholder="شماره موبایل"
        className={authInputClass}
        value={form.phone}
        onChange={update("phone")}
        autoFocus
        required
      />
      <input
        name="firstName"
        type="text"
        placeholder="نام"
        className={authInputClass}
        value={form.firstName}
        onChange={update("firstName")}
        pattern={PERSIAN_ONLY}
        title="لطفاً فقط حروف فارسی وارد کنید"
        required
      />
      <input
        name="lastName"
        type="text"
        placeholder="نام خانوادگی"
        className={authInputClass}
        value={form.lastName}
        onChange={update("lastName")}
        pattern={PERSIAN_ONLY}
        title="لطفاً فقط حروف فارسی وارد کنید"
        required
      />
    </AuthShell>
  );
};

export default SignUpPage;
